import * as React from 'react';
import { CianNewbuildingChatButtonContext } from '@cian/newbuilding-chat-component';

import { SinglePhoneComponent } from '../../components/SinglePhoneComponent';
import { trackShowPhone } from '../NewbuildingCallButton/tracking';

type TChatContext = React.ContextType<typeof CianNewbuildingChatButtonContext>;
type TCallRendererProps = React.ComponentProps<TChatContext['CallComponent']>;

interface INewbuildingChatCallComponentProps extends TCallRendererProps {
  newbuildingId: number;
  url: string;
}

interface IContactPhone {
  code: string;
  countryCode: string;
  number: string;
}

// Форматирование телефона как в @cian/frontend-newbuilding-call-component (cropPhone): "+7 495 123 45 67".
function formatPhone(phone?: IContactPhone | null): string {
  if (!phone || !phone.countryCode || !phone.code || !phone.number) {
    return '';
  }

  const countryCode = phone.countryCode === '7' || phone.countryCode === '8' ? '+7' : phone.countryCode;
  const number = phone.number.length === 7 ? phone.number.replace(/(^\d{3})(\d{2})(\d{2}$)/, '$1 $2 $3') : phone.number;

  return `${countryCode} ${phone.code} ${number}`;
}

/**
 * Компонент звонка внутри модалки контактов чата (библиотека рендерит его для каждого контакта).
 * По клику отправляет событие 20 (расхлоп телефона) с seller_type и показывает статический телефон.
 */
export const NewbuildingChatCallComponent = ({
  builders,
  sellers,
  CallButtonComponent,
  newbuildingId,
  url,
}: INewbuildingChatCallComponentProps) => {
  const [isPhoneShown, setIsPhoneShown] = React.useState(false);

  // Из библиотеки чата ожидается только один контакт.
  const contact = [...sellers, ...builders][0];
  const isBuilder = builders.length > 0;
  const phone = formatPhone(contact?.phone);

  const handleClick = React.useCallback(() => {
    trackShowPhone({ newbuildingId, url, sellerType: isBuilder ? 'builders' : 'agents' });
    setIsPhoneShown(true);
  }, [newbuildingId, url, isBuilder]);

  if (isPhoneShown && phone) {
    return <SinglePhoneComponent phone={phone} size="M" />;
  }

  return <CallButtonComponent onClick={handleClick} />;
};
